
import React, { Component } from 'react';
import { Button, Row, Col, Card, CardHeader, CardTitle,CardBody,Table,
Modal, ModalHeader,ModalBody,ModalFooter,FormGroup,Label,Input,CustomInput,
Badge, Container
} from 'reactstrap';
// import classNames from "classnames";
// import { getTextOfJSDocComment } from 'typescript';
import numberWithCommas from "../constant/numberFormat.js"

const common_field=[
    {title:"押金",fieldName:"deposit"},
    {title:"Fee (%)",fieldName:"feePercentage"},
    {title:"保險 (%)",fieldName:"insurancePercentage"},
    {title:"備註",fieldName:"memo"},
    {title:"額外交收",fieldName:"additionalPay"},
    {title:"提前交收",fieldName:"earlyPay"},
    // 注意：boolean 欄位移到 checkbox 區域處理，不在這裡定義
    // {title:"Value Store",fieldName:"valueStore"}
]

// 系統設定 boolean 欄位（按照指定順序）
const system_boolean_field=[
    {title:"交收制度",fieldName:"valueStore"},
    {title:"使用階梯",fieldName:"usingLadder"},
]

// 新增的全層級通用 boolean 欄位（按照指定順序）
const common_boolean_field=[
    {title:"參加LB",fieldName:"participateLB"},
    {title:"分攤LB",fieldName:"shareLeaderboard"},
    {title:"代理線生態審核",fieldName:"auditAgentsAndPredeductEcoFund"},
    {title:"額外一倍LB",fieldName:"extraLeaderboardReward"},
]

// 9527聯盟俱樂部限定欄位
const club_9527_field=[
    {title:"套用tax",fieldName:"mandatoryEcoFund"}
]

const union_field=[
    {title:"聯盟名",fieldName:"unionName"},
    {title:"聯盟ID",fieldName:"unionID"},
    {title:"水前輸贏佔成",fieldName:"preRakeSharing"}
]

const club_field=[
    {title:"俱樂部名",fieldName:"clubName"},
    {title:"俱樂部ID",fieldName:"clubID"}
]

const agent_field=[
    {title:"代理名",fieldName:"agentName"},
    {title:"代理ID",fieldName:"agentID"}
]

const sub_agent_field=[
    {title:"子代理名",fieldName:"subAgentName"},
    {title:"子代理ID",fieldName:"subAgentID"}
]

union_field.push(...common_field);
club_field.push(...common_field);
agent_field.push(...common_field);
sub_agent_field.push(...common_field);

class UnionInfo extends Component {
    constructor(props) {
      super(props);
      this.state = {
        showingClubs: false,
        showingAgents: false,
        openDeleteModal: false,
        openAPModal: false,
        openDeleteAPModal: false,

        insertModalisOpen: false,
        submitType:"",
        editInfo:{
            unionName:"",
            unionID:"",
            deposit:"",
            feePercentage:"",
            insurancePercentage:"",
            memo:"",
            additionalPay:"",
            valueStore: false,
            usingLadder: false,
            // 新增的全層級通用欄位
            participateLB: false,
            auditAgentsAndPredeductEcoFund: false,
            extraLeaderboardReward: false,
            shareLeaderboard: false,
            // 9527聯盟俱樂部限定欄位
            mandatoryEcoFund: false,
        },
        currentView:"union",
        viewMode: "table", // "card" or "table" - 預設為表格
        showFilters: false,
        filters: {
            id: "",
            name: "",
            valueStore: "all", // "all", "true", "false"
            usingLadder: "all",
            participateLB: "all",
            auditAgentsAndPredeductEcoFund: "all",
            extraLeaderboardReward: "all",
            shareLeaderboard: "all",
            mandatoryEcoFund: "all",
            additionalPay: "all", // "all", "hasValue", "noValue"
            earlyPay: "all" // "all", "hasValue", "noValue"
        },
        clubData:[],
        agentData:[],
        deleteData:{},
        viewAplist:[],
        editAPlist:{
            APevent:"",
            APamount:"",
        }
      };
      this.handleChange = this.handleChange.bind(this);
      this.handleChangeNewAP = this.handleChangeNewAP.bind(this);
      
      this.resetValue = this.resetValue.bind(this);
      this.confirmDelete = this.confirmDelete.bind(this);
      this.closeConfirmModal = this.closeConfirmModal.bind(this);

      
      
    }

    componentDidUpdate(prevProps, PrevState) {
    if (prevProps.union_info !== this.props.union_info && typeof this.state.targetUnion !== 'undefined') {
        for(let i = 0; i< this.props.union_info.length; i++){
            if(this.props.union_info[i]._id === this.state.targetUnion._id){
                this.setState({ targetUnion: this.props.union_info[i] })

                if (typeof this.state.targetClub !== "undefined"){
                    let clubs = Object.values(this.props.union_info[i].clubs)
                    for (let j = 0; j< clubs.length; j++){
                        if(clubs[j].clubID === this.state.targetClub.clubID){
                            this.setState({ targetClub: clubs[j] })

                            if (typeof this.state.targetAgent !== "undefined"){
                                let agents = Object.values(clubs[j].agents)
                                for (let k = 0; k< agents.length; k++){
                                    if(agents[k].agentID === this.state.targetAgent.agentID){
                                        this.setState({ targetAgent: agents[k] })
                                    }
                                }
                            }
                        }
                    }
                } 
            }
        }
      }
    }
  
    componentDidMount() {
        this.props.onLoad();
    }
  
    componentWillUnmount() {
        
    }

    resetValue = ()=>{
        this.setState({ 
            editInfo:{}, 
            submitType:"",
        })
    }

    handleChange = (e) =>{
        this.setState({ editInfo: {...this.state.editInfo, [e.target.name]: e.target.value }});
    }

    openInsertModal = () =>{
        this.setState({
            insertModalisOpen:true
        })
    }

    submitNewUnion = () =>{
        if (this.state.submitType==="insert"){
            if(this.state.currentView==="union"){
                this.props.onSubmitNewUnion(this.state.editInfo)
            }else if(this.state.currentView==="club"){
                this.props.onSubmitNewClub(this.state.targetUnion._id,this.state.editInfo)
            }else if(this.state.currentView==="agent"){
                this.props.onSubmitNewAgent(this.state.targetUnion._id,this.state.targetClub.clubID,this.state.editInfo)
            }else if(this.state.currentView==="subAgent"){
                this.props.onSubmitNewSubAgent(this.state.targetUnion._id,this.state.targetClub.clubID,this.state.targetAgent.agentID,this.state.editInfo)
            }
            
        }else if(this.state.submitType==="update"){
            if(this.state.currentView==="union"){
                this.props.onUpdateUnion(this.state.editInfo)
            }else if(this.state.currentView==="club"){
                this.props.onUpdateClub(this.state.targetUnion._id,this.state.editInfo)
            }else if(this.state.currentView==="agent"){
                this.props.onUpdateAgent(this.state.targetUnion._id,this.state.targetClub.clubID,this.state.editInfo)
            }else if(this.state.currentView==="subAgent"){
                this.props.onUpdateSubAgent(this.state.targetUnion._id,this.state.targetClub.clubID,this.state.targetAgent.agentID,this.state.editInfo)
            }
            
        }
        
        this.closeInsertModal()
    }

    closeInsertModal = () =>{
        this.setState({
            insertModalisOpen:false
        })
        this.resetValue()
    }

    validInput = ()=>{
        // if (typeof this.state.editInfo.unionName !== "undefined" && typeof this.state.editInfo.unionID !== "undefined" && 
        //      this.state.editInfo.unionName!=="" && this.state.editInfo.unionID!==""){
        //     return false
        // }else{
        //     return true
        // }
        return false
    }

    deleteInfo = (data) =>{
        // console.log(data)
        this.setState({openDeleteModal:true, deleteData:data})
    }

    confirmDelete = () =>{
        let data = this.state.deleteData
        if(this.state.currentView==="union"){
            this.props.onDeleteUnion(data._id)
        }else if(this.state.currentView==="club"){
            this.props.onDeleteClub(this.state.targetUnion._id, data.clubID)
        }else if(this.state.currentView==="agent"){
            this.props.onDeleteAgent(this.state.targetUnion._id, this.state.targetClub.clubID, data.agentID)
        }else if(this.state.currentView==="subAgent"){
            this.props.onDeleteSubAgent(this.state.targetUnion._id, this.state.targetClub.clubID, this.state.targetAgent.agentID, data.subAgentID)
            // this.props.onDeleteAgent(this.state.targetUnion._id, this.state.targetClub.clubID, data.agentID)
        }
        this.closeConfirmModal()
    }

    closeConfirmModal = () =>{
        this.setState({openDeleteModal:false})
    }


 
    updateUnionInfo = (union) =>{
        if (typeof union.usingLadder === "undefined"){
            union['usingLadder'] = false
        }
        
        // 設定新欄位的預設值
        if (typeof union.participateLB === "undefined"){
            union['participateLB'] = false
        }
        if (typeof union.auditAgentsAndPredeductEcoFund === "undefined"){
            union['auditAgentsAndPredeductEcoFund'] = false
        }
        if (typeof union.extraLeaderboardReward === "undefined"){
            union['extraLeaderboardReward'] = false
        }
        if (typeof union.shareLeaderboard === "undefined"){
            union['shareLeaderboard'] = false
        }
        if (typeof union.mandatoryEcoFund === "undefined"){
            union['mandatoryEcoFund'] = false
        }
        
        // 確保邏輯一致性：不參加LB的人不能分攤LB
        if (!union.participateLB && union.shareLeaderboard) {
            union['shareLeaderboard'] = false
        }
        
        this.setState({
            editInfo:union,
            submitType:"update"
        })
        this.openInsertModal()
    }

    clickBack = () =>{
        // 重置篩選器
        this.clearFilters();
        
        if(this.state.currentView==="club"){
            this.setState({
                currentView:"union",
                // targetUnion:"",
                // targetClub:""
            })
            delete this.state.targetUnion
            delete this.state.targetClub
            delete this.state.targetAgent
        }else if(this.state.currentView==="agent"){
            this.setState({
                currentView:"club",
                // targetClub:""
            })
            delete this.state.targetClub
            delete this.state.targetAgent
        }else if(this.state.currentView==="subAgent"){
            this.setState({
                currentView:"agent",
            })
            delete this.state.targetAgent
        }
    }

    addInfo = () =>{
        let nameField = union_field[0].fieldName
        let idField = union_field[1].fieldName
        
        if(this.state.currentView==="club"){
            nameField = club_field[0].fieldName
            idField = club_field[1].fieldName
        }else if(this.state.currentView==="agent"){
            nameField = agent_field[0].fieldName
            idField = agent_field[1].fieldName
        }else if(this.state.currentView==="subAgent"){
            nameField = sub_agent_field[0].fieldName
            idField = sub_agent_field[1].fieldName
        }  
       
        let editInfo = {
            [nameField]:"",
            [idField]:"",
            deposit:"",
            feePercentage:"",
            insurancePercentage:"",
            memo:"",
            additionalPay:"",
            valueStore: false,
            usingLadder: false,
            // 新增的全層級通用欄位
            participateLB: false,
            auditAgentsAndPredeductEcoFund: false,
            extraLeaderboardReward: false,
            shareLeaderboard: false,
            // 9527聯盟俱樂部限定欄位
            mandatoryEcoFund: false
        }
        
        // 聯盟層級限定欄位
        if(this.state.currentView==="union"){
            editInfo.preRakeSharing = ""
        }
        
        this.setState({
            submitType:"insert",
            editInfo: editInfo
        })
        this.openInsertModal()
    }

    getObjectValue=(data,option)=>{
        return Object.values(data[option])
    }

    switchToClub = (data) =>{
        this.clearFilters();
        this.setState({currentView:"club", targetUnion: data})
    }

    switchToAgents = (data) =>{
        this.clearFilters();
        this.setState({currentView:"agent", targetClub: data})
    }

    switchToSubAgents= (data) =>{
        this.clearFilters();
        this.setState({currentView:"subAgent", targetAgent: data})
    }

    onClickValueStore = () =>{
        const newValueStore = !this.state.editInfo.valueStore;
        const newParticipateLB = newValueStore ? true : this.state.editInfo.participateLB;
        this.setState({
            editInfo: {
                ...this.state.editInfo, 
                valueStore: newValueStore,
                // 當valueStore為true時，參加LB強制為true
                participateLB: newParticipateLB,
                // 如果不參加LB，自動設定不分攤LB
                shareLeaderboard: newParticipateLB ? this.state.editInfo.shareLeaderboard : false
            },
        })
    }

    onClickLadder = () =>{
        this.setState({
            editInfo: {...this.state.editInfo, usingLadder: !this.state.editInfo.usingLadder},
        })
    }

    onClickParticipateLB = () =>{
        // 只有在 valueStore 為 false 時才允許切換
        if (!this.state.editInfo.valueStore) {
            const newParticipateLB = !this.state.editInfo.participateLB;
            this.setState({
                editInfo: {
                    ...this.state.editInfo, 
                    participateLB: newParticipateLB,
                    // 如果不參加LB，自動設定不分攤LB
                    shareLeaderboard: newParticipateLB ? this.state.editInfo.shareLeaderboard : false
                }
            })
        }
    }

    onClickAuditAgents = () =>{
        this.setState({
            editInfo: {...this.state.editInfo, auditAgentsAndPredeductEcoFund: !this.state.editInfo.auditAgentsAndPredeductEcoFund},
        })
    }

    onClickExtraLeaderboard = () =>{
        this.setState({
            editInfo: {...this.state.editInfo, extraLeaderboardReward: !this.state.editInfo.extraLeaderboardReward},
        })
    }

    onClickMandatoryEcoFund = () =>{
        this.setState({
            editInfo: {...this.state.editInfo, mandatoryEcoFund: !this.state.editInfo.mandatoryEcoFund},
        })
    }

    onClickShareLeaderboard = () =>{
        // 只有在參加LB的情況下才允許切換分攤LB
        if (this.state.editInfo.participateLB) {
            this.setState({
                editInfo: {...this.state.editInfo, shareLeaderboard: !this.state.editInfo.shareLeaderboard},
            })
        }
    }

    toggleViewMode = () => {
        this.setState({
            viewMode: this.state.viewMode === "card" ? "table" : "card"
        })
    }

    toggleFilters = () => {
        this.setState({
            showFilters: !this.state.showFilters
        })
    }

    handleFilterChange = (filterName, value) => {
        this.setState({
            filters: {
                ...this.state.filters,
                [filterName]: value
            }
        })
    }

    clearFilters = () => {
        this.setState({
            filters: {
                id: "",
                name: "",
                valueStore: "all",
                usingLadder: "all",
                participateLB: "all",
                auditAgentsAndPredeductEcoFund: "all",
                extraLeaderboardReward: "all",
                shareLeaderboard: "all",
                mandatoryEcoFund: "all",
                additionalPay: "all",
                earlyPay: "all"
            }
        })
    }

    applyFilters = (data) => {
        const { filters } = this.state;
        
        return data.filter(item => {
            // ID篩選 - 部分匹配
            if (filters.id && !this.getItemId(item).toLowerCase().includes(filters.id.toLowerCase())) {
                return false;
            }
            
            // 名稱篩選 - 部分匹配
            if (filters.name && !this.getItemName(item).toLowerCase().includes(filters.name.toLowerCase())) {
                return false;
            }
            
            // Boolean欄位篩選
            if (filters.valueStore !== "all" && String(item.valueStore) !== filters.valueStore) {
                return false;
            }
            
            if (filters.usingLadder !== "all" && String(item.usingLadder) !== filters.usingLadder) {
                return false;
            }
            
            if (filters.participateLB !== "all" && String(item.participateLB) !== filters.participateLB) {
                return false;
            }
            
            if (filters.auditAgentsAndPredeductEcoFund !== "all" && String(item.auditAgentsAndPredeductEcoFund) !== filters.auditAgentsAndPredeductEcoFund) {
                return false;
            }
            
            if (filters.extraLeaderboardReward !== "all" && String(item.extraLeaderboardReward) !== filters.extraLeaderboardReward) {
                return false;
            }
            
            if (filters.shareLeaderboard !== "all" && String(item.shareLeaderboard) !== filters.shareLeaderboard) {
                return false;
            }
            
            if (filters.mandatoryEcoFund !== "all" && String(item.mandatoryEcoFund) !== filters.mandatoryEcoFund) {
                return false;
            }
            
            // 額外交收篩選
            if (filters.additionalPay !== "all") {
                const hasValue = item.additionalPay && item.additionalPay !== "" && item.additionalPay !== null;
                if (filters.additionalPay === "hasValue" && !hasValue) {
                    return false;
                }
                if (filters.additionalPay === "noValue" && hasValue) {
                    return false;
                }
            }
            
            // 提前交收篩選
            if (filters.earlyPay !== "all") {
                const hasValue = item.earlyPay && item.earlyPay !== "" && item.earlyPay !== null;
                if (filters.earlyPay === "hasValue" && !hasValue) {
                    return false;
                }
                if (filters.earlyPay === "noValue" && hasValue) {
                    return false;
                }
            }
            
            return true;
        });
    }

    getItemId = (item) => {
        if(this.state.currentView === "union") return item.unionID || "";
        if(this.state.currentView === "club") return item.clubID || "";
        if(this.state.currentView === "agent") return item.agentID || "";
        if(this.state.currentView === "subAgent") return item.subAgentID || "";
        return "";
    }

    getItemName = (item) => {
        if(this.state.currentView === "union") return item.unionName || "";
        if(this.state.currentView === "club") return item.clubName || "";
        if(this.state.currentView === "agent") return item.agentName || "";
        if(this.state.currentView === "subAgent") return item.subAgentName || "";
        return "";
    }

    renderFilters = () => {
        const { filters, currentView } = this.state;
        const fields = this.getFields();
        const booleanFields = fields.filter(field => 
            ['usingLadder', 'valueStore', 'participateLB', 'auditAgentsAndPredeductEcoFund', 'extraLeaderboardReward', 'shareLeaderboard', 'mandatoryEcoFund'].includes(field.fieldName)
        );
        
        if (!this.state.showFilters) return null;

        return (
            <Card className="mb-3" style={{
                backgroundColor: '#3a4a5c',
                border: '1px solid #495964',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
            }}>
                <CardHeader style={{
                    backgroundColor: '#2f3d4a',
                    borderBottom: '1px solid #495964',
                    borderTopLeftRadius: '7px',
                    borderTopRightRadius: '7px',
                    padding: '1rem 1.25rem'
                }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="mb-0" style={{ color: '#e9ecef' }}>
                            <i className="fa fa-filter mr-2" style={{ color: '#6c757d' }}></i>
                            篩選條件
                        </h6>
                        <Button 
                            color="secondary" 
                            size="sm" 
                            onClick={(e) => {
                                this.clearFilters();
                                e.target.blur();
                            }}
                            style={{
                                background: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)',
                                border: 'none',
                                color: '#ffffff',
                                fontWeight: '600',
                                borderRadius: '6px',
                                padding: '6px 12px',
                                boxShadow: '0 2px 6px rgba(108, 117, 125, 0.3)',
                                transition: 'all 0.2s ease',
                                outline: 'none'
                            }}
                            onMouseLeave={(e) => e.target.blur()}
                        >
                            <i className="fa fa-refresh mr-1"></i>
                            清除篩選
                        </Button>
                    </div>
                </CardHeader>
                <CardBody style={{
                    backgroundColor: '#3a4a5c',
                    color: '#e9ecef',
                    borderBottomLeftRadius: '7px',
                    borderBottomRightRadius: '7px',
                    padding: '1.25rem'
                }}>
                    <Row>
                        {/* ID篩選 */}
                        <Col md="6" lg="3" className="mb-3">
                            <Label className="form-label" style={{ color: '#bdc3c7', fontWeight: '500' }}>
                                {currentView === "union" ? "聯盟ID" : 
                                 currentView === "club" ? "俱樂部ID" :
                                 currentView === "agent" ? "代理ID" : "子代理ID"}
                            </Label>
                            <Input
                                type="text"
                                placeholder="輸入ID進行搜尋..."
                                value={filters.id}
                                onChange={(e) => this.handleFilterChange("id", e.target.value)}
                                style={{
                                    backgroundColor: '#2c3e50',
                                    border: '1px solid #495964',
                                    color: '#e9ecef',
                                    borderRadius: '6px'
                                }}
                            />
                        </Col>

                        {/* 名稱篩選 */}
                        <Col md="6" lg="3" className="mb-3">
                            <Label className="form-label" style={{ color: '#bdc3c7', fontWeight: '500' }}>
                                {currentView === "union" ? "聯盟名" : 
                                 currentView === "club" ? "俱樂部名" :
                                 currentView === "agent" ? "代理名" : "子代理名"}
                            </Label>
                            <Input
                                type="text"
                                placeholder="輸入名稱進行搜尋..."
                                value={filters.name}
                                onChange={(e) => this.handleFilterChange("name", e.target.value)}
                                style={{
                                    backgroundColor: '#2c3e50',
                                    border: '1px solid #495964',
                                    color: '#e9ecef',
                                    borderRadius: '6px'
                                }}
                            />
                        </Col>



                        {/* 額外交收篩選 */}
                        <Col md="6" lg="3" className="mb-3">
                            <Label className="form-label" style={{ color: '#bdc3c7', fontWeight: '500' }}>額外交收</Label>
                            <Input
                                type="select"
                                value={filters.additionalPay}
                                onChange={(e) => this.handleFilterChange("additionalPay", e.target.value)}
                                style={{
                                    backgroundColor: '#2c3e50',
                                    border: '1px solid #495964',
                                    color: '#e9ecef',
                                    borderRadius: '6px'
                                }}
                            >
                                <option value="all">全部</option>
                                <option value="hasValue">有值</option>
                                <option value="noValue">無值</option>
                            </Input>
                        </Col>

                        {/* 提前交收篩選 */}
                        <Col md="6" lg="3" className="mb-3">
                            <Label className="form-label" style={{ color: '#bdc3c7', fontWeight: '500' }}>提前交收</Label>
                            <Input
                                type="select"
                                value={filters.earlyPay}
                                onChange={(e) => this.handleFilterChange("earlyPay", e.target.value)}
                                style={{
                                    backgroundColor: '#2c3e50',
                                    border: '1px solid #495964',
                                    color: '#e9ecef',
                                    borderRadius: '6px'
                                }}
                            >
                                <option value="all">全部</option>
                                <option value="hasValue">有值</option>
                                <option value="noValue">無值</option>
                            </Input>
                        </Col>

                        {/* 新功能Boolean欄位篩選 */}
                        {booleanFields.map((field, index) => (
                            <Col key={index} md="6" lg="3" className="mb-3">
                                <Label className="form-label" style={{ color: '#bdc3c7', fontWeight: '500' }}>{field.title}</Label>
                                <Input
                                    type="select"
                                    value={filters[field.fieldName]}
                                    onChange={(e) => this.handleFilterChange(field.fieldName, e.target.value)}
                                    style={{
                                        backgroundColor: '#2c3e50',
                                        border: '1px solid #495964',
                                        color: '#e9ecef',
                                        borderRadius: '6px'
                                    }}
                                >
                                    <option value="all">全部</option>
                                    {field.fieldName === 'valueStore' ? (
                                        <>
                                            <option value="true">儲值制</option>
                                            <option value="false">信用制</option>
                                        </>
                                    ) : (
                                        <>
                                            <option value="true">是</option>
                                            <option value="false">否</option>
                                        </>
                                    )}
                                </Input>
                            </Col>
                        ))}
                    </Row>
                </CardBody>
            </Card>
        );
    }

    getFields = () =>{
        let fields
        if(this.state.currentView==="union"){
            fields = [...union_field, ...system_boolean_field, ...common_boolean_field]
        }else if(this.state.currentView==="club"){
            fields = [...club_field, ...system_boolean_field, ...common_boolean_field]
            // 如果是9527聯盟的俱樂部，添加特殊欄位
            if(this.state.targetUnion && this.state.targetUnion.unionID === "9527"){
                fields = fields.concat(club_9527_field)
            }
        }else if(this.state.currentView==="agent"){
            fields = [...agent_field, ...system_boolean_field, ...common_boolean_field]
        }else if(this.state.currentView==="subAgent"){
            fields = [...sub_agent_field, ...system_boolean_field, ...common_boolean_field]
        }
        return fields
    }

    getHeader = () =>{
        let header
        if(this.state.currentView==="union"){
            header = "聯盟資訊"
        }else if(this.state.currentView==="club"){
            header = "俱樂部資訊: " + this.state.targetUnion.unionID + " " + this.state.targetUnion.unionName
        }else if(this.state.currentView==="agent"){
            header = "代理資訊 " + this.state.targetClub.clubID + " " + this.state.targetClub.clubName
        }else if(this.state.currentView==="subAgent"){
            header = "子代理資訊 " + this.state.targetAgent.agentID + " " + this.state.targetAgent.agentName
        }
        return header
    }

    getData = () => {
        let data
        if(this.state.currentView==="union"){
            data = this.props.union_info
        }else if(this.state.currentView==="club"){
            data = Object.values(this.state.targetUnion.clubs)
        }else if(this.state.currentView==="agent"){
            data = Object.values(this.state.targetClub.agents)
        }else if(this.state.currentView==="subAgent"){
            data = Object.values(this.state.targetAgent.subAgents)
        }
        
        // 應用篩選
        if (data && data.length > 0) {
            data = this.applyFilters(data);
        }
        
        return data
    }

    getButton = (data)=>{
        let button
        if(this.state.currentView==="union"){
            button = (
                <Button color='info'  size='sm' id={`ViewClubs_${data._id}`} style={{marginLeft:5}} onClick={() =>{this.switchToClub(data)}} >
                    旗下俱樂部
                </Button>
                )
        }else if(this.state.currentView==="club"){
            button = (
                <Button color='info'  size='sm' id={`ViewAgents_${data._id}`} style={{marginLeft:5}} onClick={() =>{this.switchToAgents(data)}} >
                    旗下代理
                </Button>
            )
        }else if(this.state.currentView==="agent"){
            button = (
                <Button color='info'  size='sm' id={`ViewSubAgents_${data._id}`} style={{marginLeft:5}} onClick={() =>{this.switchToSubAgents(data)}} >
                    旗下子代理
                </Button>
            )
        }else if(this.state.currentView==="subAgent"){
            button = null
        }
        
        return button
    }

    getCardNavigationButton = (data)=>{
        let button = null
        if(this.state.currentView==="union"){
            button = (
                <Button 
                    size='sm' 
                    id={`ViewClubs_${data._id}`} 
                    onClick={(e) => {
                        this.switchToClub(data);
                        e.target.blur();
                    }}
                    style={{
                        marginLeft: 5,
                        background: 'linear-gradient(135deg, #FFD93D 0%, #FF9500 100%)',
                        border: 'none',
                        color: '#ffffff',
                        fontSize: '0.8rem',
                        fontWeight: '600',
                        borderRadius: '20px',
                        padding: '6px 14px',
                        boxShadow: '0 3px 10px rgba(255, 149, 0, 0.3)',
                        transition: 'all 0.2s ease',
                        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                        outline: 'none'
                    }}
                    onMouseLeave={(e) => e.target.blur()}
                >
                    旗下俱樂部
                </Button>
            )
        }else if(this.state.currentView==="club"){
            button = (
                <Button 
                    size='sm' 
                    id={`ViewAgents_${data._id}`} 
                    onClick={(e) => {
                        this.switchToAgents(data);
                        e.target.blur();
                    }}
                    style={{
                        marginLeft: 5,
                        background: 'linear-gradient(135deg, #FFD93D 0%, #FF9500 100%)',
                        border: 'none',
                        color: '#ffffff',
                        fontSize: '0.8rem',
                        fontWeight: '600',
                        borderRadius: '20px',
                        padding: '6px 14px',
                        boxShadow: '0 3px 10px rgba(255, 149, 0, 0.3)',
                        transition: 'all 0.2s ease',
                        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                        outline: 'none'
                    }}
                    onMouseLeave={(e) => e.target.blur()}
                >
                    旗下代理
                </Button>
            )
        }else if(this.state.currentView==="agent"){
            button = (
                <Button 
                    size='sm' 
                    id={`ViewSubAgents_${data._id}`} 
                    onClick={(e) => {
                        this.switchToSubAgents(data);
                        e.target.blur();
                    }}
                    style={{
                        marginLeft: 5,
                        background: 'linear-gradient(135deg, #FFD93D 0%, #FF9500 100%)',
                        border: 'none',
                        color: '#ffffff',
                        fontSize: '0.8rem',
                        fontWeight: '600',
                        borderRadius: '20px',
                        padding: '6px 14px',
                        boxShadow: '0 3px 10px rgba(255, 149, 0, 0.3)',
                        transition: 'all 0.2s ease',
                        textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                        outline: 'none'
                    }}
                    onMouseLeave={(e) => e.target.blur()}
                >
                    旗下子代理
                </Button>
            )
        }else if(this.state.currentView==="subAgent"){
            button = null
        }
        
        return button
    }

    getAddButton= ()=>{
        let text 
        if(this.state.currentView==="union"){
            text = "新增聯盟"
        }else if(this.state.currentView==="club"){
            text = "新增俱樂部"
        }else if(this.state.currentView==="agent"){
            text = "新增代理"
        }else if(this.state.currentView==="subAgent"){
            text = "新增子代理"
        }
        return text
    }

    subAgentsRow = (data) =>{
        // 子代理頁面不顯示這個組件
        if (this.state.currentView === "subAgent") {
            return null;
        }
        
        if (typeof data.subAgents!=="undefined"){
            let sub_agent_list =  Object.values(data.subAgents) 
            // 如果沒有子代理就不顯示區塊
            if (sub_agent_list.length === 0) {
                return null;
            }
            return (
                <tr key={`subagents-${data.agentID}`}>
                    <td colSpan="100%" style={{ 
                        padding: '0px',
                        border: 'none',
                        backgroundColor: 'transparent'
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #5a6c7d 0%, #4a5b6c 100%)',
                            borderRadius: '12px',
                            margin: '8px 16px',
                            padding: '2px',
                            boxShadow: '0 4px 15px rgba(90, 108, 125, 0.15)'
                        }}>
                            <div style={{
                                backgroundColor: '#3c4d5e',
                                borderRadius: '10px',
                                padding: '16px 20px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '12px',
                                    paddingBottom: '10px',
                                    borderBottom: '2px solid #4a5b6c'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #5a6c7d 0%, #4a5b6c 100%)',
                                        borderRadius: '50%',
                                        width: '28px',
                                        height: '28px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '12px',
                                        boxShadow: '0 2px 8px rgba(90, 108, 125, 0.3)'
                                    }}>
                                        <i className="fa fa-users" style={{ 
                                            color: '#ffffff', 
                                            fontSize: '14px'
                                        }}></i>
                                    </div>
                                    <span style={{
                                        fontWeight: '700',
                                        color: '#d6dde4',
                                        fontSize: '15px',
                                        letterSpacing: '0.5px'
                                    }}>
                                        旗下子代理
                                    </span>
                                    <div style={{
                                        marginLeft: '10px',
                                        background: 'linear-gradient(135deg, #5a6c7d 0%, #4a5b6c 100%)',
                                        color: '#ffffff',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        padding: '3px 8px',
                                        borderRadius: '12px',
                                        boxShadow: '0 2px 4px rgba(90, 108, 125, 0.2)'
                                    }}>
                                        {sub_agent_list.length}
                                    </div>
                                </div>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                                    gap: '12px',
                                    alignItems: 'start'
                                }}>
                                    {sub_agent_list.map((subagent, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                background: 'linear-gradient(135deg, #8a9bb0 0%, #7a8b9e 100%)',
                                                borderRadius: '10px',
                                                padding: '2px',
                                                transition: 'all 0.3s ease',
                                                cursor: 'default',
                                                boxShadow: '0 2px 8px rgba(138, 155, 176, 0.2)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-2px) scale(1.02)';
                                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(138, 155, 176, 0.4)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0px) scale(1)';
                                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(138, 155, 176, 0.2)';
                                            }}
                                        >
                                            <div style={{
                                                backgroundColor: '#677284',
                                                borderRadius: '8px',
                                                padding: '12px 14px',
                                                height: '100%'
                                            }}>
                                                {/* UID在上面 */}
                                                <div style={{ 
                                                    fontSize: '12px', 
                                                    color: '#d4dce6',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    backgroundColor: '#596879',
                                                    padding: '4px 8px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #7a8b9e',
                                                    marginBottom: '6px'
                                                }}>
                                                    <i className="fa fa-id-badge" style={{ 
                                                        marginRight: '6px',
                                                        fontSize: '11px',
                                                        color: '#a8b5c4'
                                                    }}></i>
                                                    <span style={{ fontWeight: '700' }}>
                                                        UID: {subagent.subAgentID}
                                                    </span>
                                                </div>
                                                {/* 名稱在下面 */}
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    <div style={{
                                                        background: 'linear-gradient(135deg, #8a9bb0 0%, #7a8b9e 100%)',
                                                        borderRadius: '50%',
                                                        width: '20px',
                                                        height: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '8px',
                                                        flexShrink: 0
                                                    }}>
                                                        <i className="fa fa-user" style={{ 
                                                            color: '#ffffff', 
                                                            fontSize: '10px'
                                                        }}></i>
                                                    </div>
                                                    <div style={{ 
                                                        fontWeight: '500', 
                                                        fontSize: '14px',
                                                        color: subagent.subAgentName && subagent.subAgentName.trim() ? '#f0f4f8' : '#a8b5c4',
                                                        lineHeight: '1.2',
                                                        wordBreak: 'break-word',
                                                        fontStyle: subagent.subAgentName && subagent.subAgentName.trim() ? 'normal' : 'italic'
                                                    }}>
                                                        {subagent.subAgentName && subagent.subAgentName.trim() ? subagent.subAgentName : '(未設定名稱)'}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            )
        }

        return null
        
    }

    renderTableTD = (data,field,index) =>{
        if ( (field.fieldName==="feePercentage"||field.fieldName==="insurancePercentage") && data.usingLadder===true){
            return (
                <td key={index}>
                    <Badge 
                        pill 
                        style={{
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#ffffff',
                            backgroundColor: '#8e44ad',
                            border: 'none',
                            padding: '4px 8px'
                        }}
                    >
                        <i className="fa fa-bar-chart mr-1"></i>
                        階梯
                    </Badge>
                </td>
            )
        }else if(field.fieldName==="additionalPay" && typeof data[field.fieldName]!=="undefined" && data[field.fieldName]!==null && data[field.fieldName]!==""){
            return <td key={index}>{numberWithCommas(data[field.fieldName])} <Button color='info' size='sm' id={`viewAdditionPayList_${data._id}`} style={{marginLeft:5}} onClick={()=>{this.openAPlist(data)}} > <i className='fa fa-list' /></Button></td>
        }else if(field.fieldName==="valueStore"){
            // 特殊處理交收制度顯示
            return (
                <td key={index}>
                    <Badge 
                        pill 
                        style={{
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#ffffff',
                            backgroundColor: data[field.fieldName] ? '#2980b9' : '#e67e22',
                            border: 'none',
                            padding: '4px 8px'
                        }}
                    >
                        <i className={`fa ${data[field.fieldName] ? 'fa-credit-card' : 'fa-users'} mr-1`}></i>
                        {data[field.fieldName] ? '儲值制' : '信用制'}
                    </Badge>
                </td>
            )
        }else if(field.fieldName==="usingLadder" || field.fieldName==="participateLB" || field.fieldName==="auditAgentsAndPredeductEcoFund" || field.fieldName==="extraLeaderboardReward" || field.fieldName==="shareLeaderboard" || field.fieldName==="mandatoryEcoFund"){
            // 處理boolean欄位顯示
            return <td key={index}>{(data[field.fieldName])?<i style={{color:"green"}} className="fa fa-check-circle" aria-hidden="true"></i>:<i style={{color:"red"}} className="fa-solid fa-circle-xmark" aria-hidden="true"></i>}</td>
        }else if(field.fieldName==="preRakeSharing"){
            // 水前輸贏佔成：有值顯示值，沒有顯示"無"
            const hasValue = data[field.fieldName] && data[field.fieldName]!=="";
            return (
                <td key={index}>
                    <Badge 
                        pill 
                        style={{
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#ffffff',
                            backgroundColor: hasValue ? '#27ae60' : '#95a5a6',
                            border: hasValue ? 'none' : '1px solid #7f8c8d',
                            padding: '4px 8px'
                        }}
                    >
                        <i className={`fa ${hasValue ? 'fa-percent' : 'fa-minus'} mr-1`}></i>
                        {hasValue ? data[field.fieldName] : '無'}
                    </Badge>
                </td>
            )
        }else{
            return <td key={index}>{data[field.fieldName]}</td>
        }
    }
    
    renderCardView = () => {
        let datalist = this.getData()
        return(
            <Container fluid>
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardHeader>
                                <div className="d-flex justify-content-between align-items-center flex-wrap">
                                    <CardTitle tag="h4" className="mb-2 mb-md-0">{this.getHeader()}</CardTitle>
                                                                        <div className="d-flex flex-wrap">
                                         <Button 
                                             color='info' 
                                             size='sm' 
                                             className="mr-2 mb-2 mb-md-0" 
                                             onClick={this.toggleViewMode}
                                         > 
                                             <i className={`mr-2 fa ${this.state.viewMode === "card" ? 'fa-table' : 'fa-th-large'}`} />
                                             {this.state.viewMode === "card" ? "切換至表格檢視" : "切換至卡片檢視"}
                                         </Button>

                                         <Button color='danger' size='sm' className="mr-2 mb-2 mb-md-0" onClick={()=>{this.setState({openDeleteAPModal:true})}} > 
                                             <i className='fa fa-trash' /> 清除所有額外/提前交收
                                         </Button>
                                         <Button color="success" size='sm' className="mb-2 mb-md-0" onClick={this.addInfo.bind(this)}> 
                                             <i className='fa fa-plus' /> {this.getAddButton()}
                                         </Button>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {/* 移動返回按鈕到篩選按鈕旁邊，並添加顏色區別 */}
                                <div className="mb-3">
                                    {this.state.currentView !== "union" && (
                                        <Button 
                                            color='secondary' 
                                            size='sm' 
                                            className="mr-2" 
                                            onClick={(e) => {
                                                this.clickBack();
                                                e.target.blur(); // 移除焦點
                                            }}
                                            style={{
                                                background: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)',
                                                border: 'none',
                                                color: '#ffffff',
                                                fontWeight: '600',
                                                borderRadius: '8px',
                                                padding: '8px 16px',
                                                boxShadow: '0 2px 8px rgba(108, 117, 125, 0.3)',
                                                transition: 'all 0.2s ease',
                                                outline: 'none'
                                            }}
                                            onMouseLeave={(e) => e.target.blur()} // 滑鼠離開時也移除焦點
                                        >
                                            <i className="fa fa-arrow-left mr-2" />
                                            返回
                                        </Button>
                                    )}
                                    <Button 
                                        color={this.state.showFilters ? 'warning' : 'light'} 
                                        size='sm' 
                                        className="mr-2" 
                                        onClick={(e) => {
                                            this.toggleFilters();
                                            e.target.blur(); // 移除焦點
                                        }}
                                        title="切換篩選器"
                                        style={{
                                            background: this.state.showFilters 
                                                ? 'linear-gradient(135deg, #ffc107 0%, #e0a800 100%)' 
                                                : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                            border: 'none',
                                            color: this.state.showFilters ? '#212529' : '#495057',
                                            fontWeight: '600',
                                            borderRadius: '8px',
                                            padding: '8px 16px',
                                            boxShadow: this.state.showFilters 
                                                ? '0 2px 8px rgba(255, 193, 7, 0.3)' 
                                                : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                            transition: 'all 0.2s ease',
                                            outline: 'none'
                                        }}
                                        onMouseLeave={(e) => e.target.blur()} // 滑鼠離開時也移除焦點
                                    > 
                                        <i className="mr-2 fa fa-filter" /> 
                                        篩選
                                    </Button>
                                </div>
                                {this.renderFilters()}
                                {this.renderCardGrid(datalist)}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }

    renderCardGrid = (datalist) => {
        if (!datalist || datalist.length === 0) {
            const hasActiveFilters = this.hasActiveFilters();
            return (
                <div className="text-center py-5 mt-3">
                    <i className="fa fa-inbox fa-3x text-muted mb-3"></i>
                    <p className="text-muted">
                        {hasActiveFilters ? "沒有符合篩選條件的資料" : "尚無資料"}
                    </p>
                    {hasActiveFilters && (
                        <Button color="secondary" size="sm" onClick={this.clearFilters}>
                            清除篩選條件
                        </Button>
                    )}
                </div>
            )
        }

        return (
            <>
                {this.renderResultCount(datalist)}
                <Row>
                    {datalist.map((data, index) => (
                        <Col key={index} xs="12" sm="6" lg="4" xl="3" className="mb-4 mt-3">
                            {this.renderDataCard(data)}
                        </Col>
                    ))}
                </Row>
            </>
        )
    }

    hasActiveFilters = () => {
        const { filters } = this.state;
        return filters.id !== "" || 
               filters.name !== "" || 
               filters.valueStore !== "all" ||
               filters.usingLadder !== "all" ||
               filters.participateLB !== "all" ||
               filters.auditAgentsAndPredeductEcoFund !== "all" ||
               filters.extraLeaderboardReward !== "all" ||
               filters.shareLeaderboard !== "all" ||
               filters.mandatoryEcoFund !== "all" ||
               filters.additionalPay !== "all" ||
               filters.earlyPay !== "all";
    }

    renderResultCount = (datalist) => {
        const hasActiveFilters = this.hasActiveFilters();
        if (!hasActiveFilters) return null;

        return (
            <div className="mb-3 text-muted">
                <i className="fa fa-info-circle mr-1"></i>
                找到 {datalist.length} 筆符合條件的資料
            </div>
        );
    }

    renderDataCard = (data) => {
        const fields = this.getFields()
        const basicFields = fields.filter(field => 
            !['usingLadder', 'valueStore', 'participateLB', 'auditAgentsAndPredeductEcoFund', 'extraLeaderboardReward', 'shareLeaderboard', 'mandatoryEcoFund'].includes(field.fieldName)
        )
        const booleanFields = fields.filter(field => 
            ['usingLadder', 'valueStore', 'participateLB', 'auditAgentsAndPredeductEcoFund', 'extraLeaderboardReward', 'shareLeaderboard', 'mandatoryEcoFund'].includes(field.fieldName)
        )

        return (
            <Card className="h-100 shadow-lg border-0" style={{backgroundColor: '#2c3e50', border: 'none'}}>
                <CardHeader className="text-white" style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    padding: '1rem 1.25rem',
                    borderTopLeftRadius: '0.5rem',
                    borderTopRightRadius: '0.5rem'
                }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="mb-0 font-weight-bold text-white" style={{fontSize: '1rem'}}>
                            {this.getCardTitle(data)}
                        </h6>
                        <div>
                            {this.getCardNavigationButton(data)}
                        </div>
                    </div>
                </CardHeader>
                <CardBody style={{backgroundColor: '#34495e', color: '#ecf0f1', padding: '1.25rem'}}>
                    {/* 基本資訊 */}
                    <div className="mb-3">
                        {basicFields.map((field, index) => (
                            <div key={index} className="mb-2">
                                {this.renderCardField(data, field)}
                            </div>
                        ))}
                    </div>

                    {/* 功能設定 - 按照指定順序顯示所有 boolean 欄位 */}
                    {booleanFields.length > 0 && (
                        <div className="mb-3">
                                                         <h6 className="mb-2" style={{color: '#bdc3c7', fontWeight: 'bold'}}>
                                 <i className="fa fa-cogs mr-1" style={{color: '#3498db'}}></i>
                                 功能設定
                             </h6>
                                                                                                                 <div className="d-flex flex-wrap">
                                {booleanFields.map((field, index) => {
                                    if (field.fieldName === 'valueStore') {
                                        // 特殊處理交收制度顯示
                                        return (
                                            <Badge 
                                                key={index} 
                                                pill 
                                                className="mr-1 mb-1"
                                                style={{
                                                    fontSize: '0.75rem',
                                                    fontWeight: '500',
                                                    color: '#ffffff',
                                                    backgroundColor: data[field.fieldName] ? '#2980b9' : '#e67e22',
                                                    border: 'none'
                                                }}
                                            >
                                                <i className={`fa ${data[field.fieldName] ? 'fa-credit-card' : 'fa-users'} mr-1`}></i>
                                                {data[field.fieldName] ? '儲值制' : '信用制'}
                                            </Badge>
                                        )
                                    } else {
                                        // 其他 boolean 欄位保持原樣
                                        return (
                                            <Badge 
                                                key={index} 
                                                pill 
                                                className="mr-1 mb-1"
                                                style={{
                                                    fontSize: '0.75rem',
                                                    fontWeight: '500',
                                                    color: data[field.fieldName] ? '#ffffff' : '#95a5a6',
                                                    backgroundColor: data[field.fieldName] ? '#27ae60' : '#4a5568',
                                                    border: data[field.fieldName] ? 'none' : '1px solid #5a6b7a'
                                                }}
                                            >
                                                <i className={`fa ${data[field.fieldName] ? 'fa-check' : 'fa-times'} mr-1`}></i>
                                                {field.title}
                                            </Badge>
                                        )
                                    }
                                })}
                            </div>
                        </div>
                    )}

                                         {/* 操作按鈕 */}
                     <div className="d-flex justify-content-end mt-auto">
                         <Button 
                             size='sm' 
                             onClick={(e) => {
                                 this.updateUnionInfo(data);
                                 e.target.blur();
                             }}
                             className="mr-2"
                             style={{
                                 fontSize: '0.85rem',
                                 background: 'linear-gradient(135deg, #56CCF2 0%, #2F80ED 100%)',
                                 border: 'none',
                                 color: '#ffffff',
                                 fontWeight: '600',
                                 borderRadius: '8px',
                                 padding: '8px 16px',
                                 boxShadow: '0 4px 15px rgba(47, 128, 237, 0.3)',
                                 transition: 'all 0.3s ease',
                                 textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                 outline: 'none'
                             }}
                             onMouseLeave={(e) => e.target.blur()}
                         >
                             <i className='fa fa-pencil mr-1' />
                             編輯
                         </Button>
                         <Button 
                             size='sm' 
                             onClick={(e) => {
                                 this.deleteInfo(data);
                                 e.target.blur();
                             }}
                             style={{
                                 fontSize: '0.85rem',
                                 background: 'linear-gradient(135deg, #FF6B6B 0%, #EE5A52 100%)',
                                 border: 'none',
                                 color: '#ffffff',
                                 fontWeight: '600',
                                 borderRadius: '8px',
                                 padding: '8px 16px',
                                 boxShadow: '0 4px 15px rgba(238, 90, 82, 0.3)',
                                 transition: 'all 0.3s ease',
                                 textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                 outline: 'none'
                             }}
                             onMouseLeave={(e) => e.target.blur()}
                         >
                             <i className='fa fa-trash mr-1' />
                             刪除
                         </Button>
                     </div>
                </CardBody>
            </Card>
        )
    }

    getCardTitle = (data) => {
        if(this.state.currentView==="union"){
            return `${data.unionName} (${data.unionID})`
        }else if(this.state.currentView==="club"){
            return `${data.clubName} (${data.clubID})`
        }else if(this.state.currentView==="agent"){
            return `${data.agentName} (${data.agentID})`
        }else if(this.state.currentView==="subAgent"){
            return `${data.subAgentName} (${data.subAgentID})`
        }
        return "未知"
    }

    renderCardField = (data, field) => {
        if(field.fieldName === "additionalPay" && typeof data[field.fieldName]!=="undefined" && data[field.fieldName]!==null && data[field.fieldName]!==""){
            return (
                <div className="d-flex justify-content-between align-items-center">
                    <small style={{color: '#bdc3c7', fontWeight: '500'}}>{field.title}:</small>
                    <div>
                        <span className="font-weight-bold" style={{color: '#ecf0f1'}}>{numberWithCommas(data[field.fieldName])}</span>
                                                 <Button 
                            size='sm' 
                            className="ml-2" 
                            onClick={(e) => {
                                this.openAPlist(data);
                                e.target.blur();
                            }}
                            style={{
                                background: 'linear-gradient(135deg, #A8E6CF 0%, #7FCDCD 100%)',
                                border: 'none',
                                color: '#2d5a5a',
                                fontSize: '0.75rem',
                                borderRadius: '6px',
                                fontWeight: '600',
                                padding: '4px 8px',
                                boxShadow: '0 2px 8px rgba(127, 205, 205, 0.3)',
                                transition: 'all 0.2s ease',
                                outline: 'none'
                            }}
                            onMouseLeave={(e) => e.target.blur()}
                        >
                            <i className='fa fa-list' />
                        </Button>
                    </div>
                </div>
            )
        } else if((field.fieldName==="feePercentage"||field.fieldName==="insurancePercentage") && data.usingLadder===true){
            return (
                <div className="d-flex justify-content-between align-items-center">
                    <small style={{color: '#bdc3c7', fontWeight: '500'}}>{field.title}:</small>
                    <Badge style={{backgroundColor: '#f39c12', color: '#ffffff'}}>階梯</Badge>
                </div>
            )
        } else if(field.fieldName === "preRakeSharing"){
            // 水前輸贏佔成：有值顯示值，沒有顯示"無"
            const hasValue = data[field.fieldName] && data[field.fieldName]!=="";
            return (
                <div className="d-flex justify-content-between align-items-center">
                    <small style={{color: '#bdc3c7', fontWeight: '500'}}>{field.title}:</small>
                    <Badge 
                        pill 
                        style={{
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#ffffff',
                            backgroundColor: hasValue ? '#27ae60' : '#95a5a6',
                            border: hasValue ? 'none' : '1px solid #7f8c8d',
                            padding: '4px 10px'
                        }}
                    >
                        <i className={`fa ${hasValue ? 'fa-percent' : 'fa-minus'} mr-1`}></i>
                        {hasValue ? data[field.fieldName] : '無'}
                    </Badge>
                </div>
            )
        } else if(data[field.fieldName] !== undefined && data[field.fieldName] !== null && data[field.fieldName] !== "") {
            return (
                <div className="d-flex justify-content-between align-items-center">
                    <small style={{color: '#bdc3c7', fontWeight: '500'}}>{field.title}:</small>
                    <span className="font-weight-bold" style={{color: '#ecf0f1'}}>{data[field.fieldName]}</span>
                </div>
            )
        }
        return null
    }

    renderTable = () =>{
        // 保留原始表格方法作為備用
        let datalist = this.getData()
        let fields = this.getFields()
        return(
        <Row>
            <Col xs="12">
                <Card>
                <CardHeader>
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <CardTitle tag="h4" className="mb-2 mb-md-0">{this.getHeader()}</CardTitle>
                        <div className="d-flex flex-wrap">
                            <Button 
                                color='info' 
                                size='sm' 
                                className="mr-2 mb-2 mb-md-0" 
                                onClick={this.toggleViewMode}
                                title={this.state.viewMode === "card" ? "切換至表格模式" : "切換至卡片模式"}
                            > 
                                <i className={`mr-2 fa ${this.state.viewMode === "card" ? 'fa-table' : 'fa-th-large'}`} /> 
                                {this.state.viewMode === "card" ? "切換至表格檢視" : "切換至卡片檢視"}
                            </Button>
                            <Button color='danger' size='sm' className="mr-2 mb-2 mb-md-0" onClick={()=>{this.setState({openDeleteAPModal:true})}} > 
                                <i className='fa fa-trash' /> 清除所有額外/提前交收
                            </Button>
                            <Button color="success" size='sm' className="mb-2 mb-md-0" onClick={this.addInfo.bind(this)}> 
                                <i className='fa fa-plus' /> {this.getAddButton()}
                            </Button>
                        </div>
                    </div>
                </CardHeader>
                <CardBody>
                    {/* 移動返回按鈕到篩選按鈕旁邊，並添加顏色區別 */}
                    <div className="mb-3">
                        {this.state.currentView !== "union" && (
                            <Button 
                                color='secondary' 
                                size='sm' 
                                className="mr-2" 
                                onClick={(e) => {
                                    this.clickBack();
                                    e.target.blur(); // 移除焦點
                                }}
                                style={{
                                    background: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)',
                                    border: 'none',
                                    color: '#ffffff',
                                    fontWeight: '600',
                                    borderRadius: '8px',
                                    padding: '8px 16px',
                                    boxShadow: '0 2px 8px rgba(108, 117, 125, 0.3)',
                                    transition: 'all 0.2s ease',
                                    outline: 'none'
                                }}
                                onMouseLeave={(e) => e.target.blur()} // 滑鼠離開時也移除焦點
                            >
                                <i className="fa fa-arrow-left mr-2" />
                                返回
                            </Button>
                        )}
                        <Button 
                            color={this.state.showFilters ? 'warning' : 'light'} 
                            size='sm' 
                            className="mr-2" 
                            onClick={(e) => {
                                this.toggleFilters();
                                e.target.blur(); // 移除焦點
                            }}
                            title="切換篩選器"
                            style={{
                                background: this.state.showFilters 
                                    ? 'linear-gradient(135deg, #ffc107 0%, #e0a800 100%)' 
                                    : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                border: 'none',
                                color: this.state.showFilters ? '#212529' : '#495057',
                                fontWeight: '600',
                                borderRadius: '8px',
                                padding: '8px 16px',
                                boxShadow: this.state.showFilters 
                                    ? '0 2px 8px rgba(255, 193, 7, 0.3)' 
                                    : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                transition: 'all 0.2s ease',
                                outline: 'none'
                            }}
                            onMouseLeave={(e) => e.target.blur()} // 滑鼠離開時也移除焦點
                        > 
                            <i className="mr-2 fa fa-filter" /> 
                            篩選
                        </Button>
                    </div>
                    {this.renderFilters()}
                    <Table  className="mt-3 tablesorter" responsive >
                    <thead  className="text-primary">
                        <tr>
                            {fields.map((field,index)=>(
                                <th key={index}>{field.title}</th>
                            ))}
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {(typeof datalist !== "undefined")&&
                            datalist.map((data, index) => (
                            <React.Fragment key={index}>
                            <tr>
                                {fields.map((field,index)=>(
                                    this.renderTableTD(data,field,index)
                                ))}
                                
                                <td>
                                    <Button color='success'  size='sm' id={`update_${data._id}`} style={{}} onClick={()=>{this.updateUnionInfo(data)}} >
                                        <i className='fa fa-pencil' />
                                    </Button>
                                    <Button color='danger'  size='sm' id={`delete_${data._id}`} style={{marginLeft:5}} onClick={() => this.deleteInfo(data)} >
                                        <i className='fa fa-trash' />
                                    </Button>
                                    {this.getButton(data)}
                                </td>
                            </tr>
                            
                            {
                                this.subAgentsRow(data)
                            }               
                            
                            </React.Fragment>
                        ))}
                    </tbody>
                    </Table>
                </CardBody>
                </Card>
            </Col>
        </Row>
        )
    }

    handleChangeNewAP = (e) =>{
        this.setState({ editAPlist: {...this.state.editAPlist, [e.target.name]: e.target.value }});
    }

    addTempAPlist= () =>{
        const { editAPlist, viewAplist } = this.state;
        if (editAPlist.APamount.trim() !== '' && editAPlist.APevent.trim() !== ''){
            this.setState({
                viewAplist:[ ...viewAplist, editAPlist],
                editAPlist:{APevent:"",APamount:""}
            })
        }
    }

    deleteTempAPlist= (e) =>{
        let list = this.state.viewAplist
        list.splice(e.target.id, 1);
        this.setState({viewAplist:list})
        // console.log(e.target.id)
    }

    openAPlist = (data) =>{
        // console.log(data)
        let targetName = "";
        if (this.state.currentView==="union"){
            targetName = "targetUnion"
        }else if(this.state.currentView==="club"){
            targetName = "targetClub"
        }else if(this.state.currentView==="agent"){
            targetName = "targetAgent"
        }else if(this.state.currentView==="subAgent"){
            targetName = "targetSubAgent"
        }

        this.setState({
            openAPModal:true,
            viewAplist: (typeof data.APlist!=="undefined" && Array.isArray(data.APlist) ) ? data.APlist:[],
            [targetName]:data
        })
    }

    closeAPModal = () =>{
        this.setState({
            openAPModal:false,
            viewAplist:[],
            editAPlist:{APevent:"",APamount:""}
        })
    }

    saveAPlist= () =>{
        if (this.state.currentView==="union"){
            this.props.onSaveUnionAPlist(this.state.targetUnion._id, this.state.viewAplist)
        }else if(this.state.currentView==="club"){
            this.props.onSaveClubAPlist(this.state.targetUnion._id, this.state.targetClub.clubID, this.state.viewAplist)
        }else if(this.state.currentView==="agent"){
            this.props.onSaveAgentAPlist(this.state.targetUnion._id, this.state.targetClub.clubID, this.state.targetAgent.agentID, this.state.viewAplist)
        }else if(this.state.currentView==="subAgent"){
            this.props.onSaveSubAgentAPlist(this.state.targetUnion._id, this.state.targetClub.clubID, this.state.targetAgent.agentID, this.state.targetSubAgent.subAgentID, this.state.viewAplist)
        }
        
        this.closeAPModal()
    }


    renderAPModal = () =>{
        return(
            <Modal style={{marginTop:100}} isOpen={this.state.openAPModal} contentClassName='bg-dark text-light'>
                <ModalHeader> <div style={{color:"white"}}>額外付款清單</div></ModalHeader>
                <ModalBody>
                    <Table size="sm" className="tablesorter" >
                        <thead  className="text-primary">
                            <tr>
                                <th>事件</th>
                                <th>金額</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <Input style={{height:30}} className='bg-dark text-light' type='text' id={"APevent"} name={"APevent"} value={this.state.editAPlist.APevent||""} onChange={this.handleChangeNewAP.bind(this)} /> 
                                </td>
                                <td>
                                    <Input style={{height:30}} className='bg-dark text-light' type='text' id={"APamount"} name={"APamount"} value={this.state.editAPlist.APamount||""} onChange={this.handleChangeNewAP.bind(this)} /> 
                                </td>
                                <td>
                                    <Button style={{marginRight:3}} size='sm' color="success" onClick={this.addTempAPlist.bind(this)} > + </Button>
                                </td>
                            </tr>
                            {typeof this.state.viewAplist!=="undefined" && this.state.viewAplist.map((aplist,index)=>(
                                <tr key={index}>
                                    <td>{aplist.APevent}</td>
                                    <td>{aplist.APamount}</td>
                                    <td><Button style={{marginRight:3}} id={index} size='sm' color="danger" onClick={this.deleteTempAPlist.bind(this)} > 刪除 </Button></td>
                                </tr>
                            ))}
                        </tbody>
                   
                    </Table>
                    
                    
                </ModalBody>
                <ModalFooter style={{
                    display: "flex",
                    justifyContent: "right",
                    }}>
                    <Button style={{marginRight:3}} size='sm' color="success" onClick={this.saveAPlist.bind(this)} > 儲存 </Button>
                    <Button style={{}} size='sm' color="danger" onClick={this.closeAPModal.bind(this)}> 關閉 </Button>
                </ModalFooter>
            </Modal>
        )
    }

    renderModal = () =>{
        let fields = this.getFields()
        // 過濾掉 boolean 欄位，這些會用 checkbox 或 select 單獨處理
        const textFields = fields.filter(field => 
            !['usingLadder', 'valueStore', 'participateLB', 'auditAgentsAndPredeductEcoFund', 'extraLeaderboardReward', 'shareLeaderboard', 'mandatoryEcoFund'].includes(field.fieldName)
        )

        return (
        <Modal style={{marginTop:-100}} isOpen={this.state.insertModalisOpen} contentClassName='bg-dark text-light'>
            <ModalHeader> <div style={{color:"white"}}>
                {this.state.submitType === "insert" ? "新增" : "編輯"} {this.getHeader().split(':')[0]}
            </div></ModalHeader>
            <ModalBody>
                {
                    textFields.map((field,index)=>(
                        <FormGroup style={{margin:3}}key={index}>
                        <Col >
                            <Label>{field.title}</Label>
                            <Input style={{height:30}} className='bg-dark text-light' type='text' id={field.fieldName} name={field.fieldName} value={this.state.editInfo[field.fieldName]||""} onChange={this.handleChange.bind(this)} /> 
                        </Col>
                        </FormGroup>
                    ))
                }
                {/* 按照指定順序：交收制度、使用階梯、參加LB、分攤LB、代理線生態審核、額外一倍LB */}
                <FormGroup>
                    <Col >
                        <Label for="valueStore">交收制度</Label>
                        <Input
                            type="select"
                            id="valueStore"
                            value={this.state.editInfo.valueStore ? "true" : "false"}
                            onChange={(e) => {
                                const newValue = e.target.value === "true";
                                this.setState({
                                    editInfo: {
                                        ...this.state.editInfo,
                                        valueStore: newValue,
                                        // 如果改為儲值制，強制 participateLB 為 true
                                        participateLB: newValue ? true : this.state.editInfo.participateLB,
                                        // 如果 participateLB 變為 false，shareLeaderboard 也要變為 false
                                        shareLeaderboard: (newValue ? true : this.state.editInfo.participateLB) ? this.state.editInfo.shareLeaderboard : false
                                    }
                                });
                            }}
                        >
                            <option value="false">信用制</option>
                            <option value="true">儲值制</option>
                        </Input>
                    </Col>
                </FormGroup>
                
                <FormGroup>
                    <Col>
                        <CustomInput id = {"ladder"} type="checkbox" label = "使用階梯"
                            checked={this.state.editInfo.usingLadder || ""}
                            onChange={() => { this.onClickLadder()}}
                        />
                    </Col>
                </FormGroup>
                
                <FormGroup>
                    <Col>
                        <CustomInput 
                            id = {"participateLB"} 
                            type="checkbox" 
                            label = "參加LB"
                            checked={this.state.editInfo.participateLB || false}
                            disabled={this.state.editInfo.valueStore === true}
                            onChange={() => { this.onClickParticipateLB()}}
                        />
                        {this.state.editInfo.valueStore === true && (
                            <small className="text-warning">
                                <i className="fa fa-info-circle" style={{marginRight: '4px'}}></i>
                                儲值制啟用時自動參加LB
                            </small>
                        )}
                    </Col>
                    <Col>
                        <CustomInput 
                            id = {"shareLeaderboard"} 
                            type="checkbox" 
                            label = "分攤LB"
                            checked={this.state.editInfo.shareLeaderboard || false}
                            disabled={!this.state.editInfo.participateLB}
                            onChange={() => { this.onClickShareLeaderboard()}}
                        />
                        {!this.state.editInfo.participateLB && (
                            <small className="text-info">
                                <i className="fa fa-info-circle" style={{marginRight: '4px'}}></i>
                                不參加LB時無法分攤LB
                            </small>
                        )}
                    </Col>
                </FormGroup>
                
                <FormGroup>
                    <Col>
                        <CustomInput 
                            id = {"auditAgents"} 
                            type="checkbox" 
                            label = "代理線生態審核"
                            checked={this.state.editInfo.auditAgentsAndPredeductEcoFund || false}
                            onChange={() => { this.onClickAuditAgents()}}
                        />
                    </Col>
                    <Col>
                        <CustomInput 
                            id = {"extraLeaderboard"} 
                            type="checkbox" 
                            label = "額外一倍LB"
                            checked={this.state.editInfo.extraLeaderboardReward || false}
                            onChange={() => { this.onClickExtraLeaderboard()}}
                        />
                    </Col>
                </FormGroup>
                
                {/* 9527聯盟俱樂部限定欄位 */}
                {this.state.currentView === "club" && this.state.targetUnion && this.state.targetUnion.unionID === "9527" && (
                    <FormGroup>
                        <Col>
                            <CustomInput 
                                id = {"mandatoryEcoFund"} 
                                type="checkbox" 
                                label = "套用tax"
                                checked={this.state.editInfo.mandatoryEcoFund || ""}
                                onChange={() => { this.onClickMandatoryEcoFund()}}
                            />
                        </Col>
                    </FormGroup>
                )}
            </ModalBody>
            <ModalFooter style={{
                display: "flex",
                justifyContent: "right",
                }}>
                <Button disabled={this.validInput()} style={{marginRight:3}} size='sm' color="success" onClick={this.submitNewUnion}> 
                    {this.state.submitType === "insert" ? "新增" : "更新"} 
                </Button>
                <Button style={{}} size='sm' color="danger" onClick={this.closeInsertModal}> 取消 </Button>
            </ModalFooter>
        </Modal>
        )
    }

    renderDeleteAPModal = ()=>{
        return(
            <Modal style={{marginTop:100}} isOpen={this.state.openDeleteAPModal} contentClassName='bg-dark text-light'>
                <ModalHeader> <div style={{color:"white"}}>刪除所有額外付款</div></ModalHeader>
                <ModalBody>
                    <div>您確定要刪除所有額外付款嗎？</div>                    
                </ModalBody>
                <ModalFooter style={{
                    display: "flex",
                    justifyContent: "right",
                    }}>
                    <Button style={{marginRight:3}} size='sm' color="success" onClick={()=>{this.props.confirmDeleteAllAP()  ;this.setState({openDeleteAPModal:false})}} > 確認 </Button>
                    <Button style={{}} size='sm' color="danger" onClick={()=>{this.setState({openDeleteAPModal:false})}}> 取消 </Button>
                </ModalFooter>
            </Modal>
        )
    }
    
    render() {
        return (
        <div className="content">
            <Modal style={{marginTop:100}} isOpen={this.state.openDeleteModal} contentClassName='bg-dark text-light'>
                <ModalHeader> <div style={{color:"white"}}>刪除確認</div></ModalHeader>
                <ModalBody>
                    <div>您確定要刪除此資料嗎？所有子層級資料也會一併刪除。</div>
                    
                    { (Object.keys(this.state.deleteData).length > 0)&&
                    <>
                        <div style={{fontWeight:"bold"}}>刪除類型：{this.state.currentView}</div>
                        <div style={{fontWeight:"bold"}}>名稱：{this.getItemName(this.state.deleteData)}</div>
                        <div style={{fontWeight:"bold"}}>ID：{this.getItemId(this.state.deleteData)}</div>
                    </>
                    }     
                    
                </ModalBody>
                <ModalFooter style={{
                    display: "flex",
                    justifyContent: "right",
                    }}>
                    <Button style={{marginRight:3}} size='sm' color="success" onClick={this.confirmDelete.bind(this)} > 確認 </Button>
                    <Button style={{}} size='sm' color="danger" onClick={this.closeConfirmModal.bind(this)}> 取消 </Button>
                </ModalFooter>
            </Modal>
            

            
            {this.renderDeleteAPModal()}
            {this.renderModal()}
            {this.renderAPModal()}
            {(this.state.showingClubs === false && this.state.showingAgents === false) &&
                (this.state.viewMode === "card" ? this.renderCardView() : this.renderTable())
            }
        </div>
    )}
}

export default UnionInfo;